var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home d-flex flex-column align-center ma-4"},[_c('img',{attrs:{"alt":"Logo","src":require("../assets/logo-circle.svg"),"width":200}})])}
var staticRenderFns = []

export { render, staticRenderFns }